// extracted by mini-css-extract-plugin
export default {"color-salmon":"#F5B9A1","colorSalmon":"#F5B9A1","promoArea":"PLVjI fmngK","promoIcon":"PIo-B","promoText":"lNjuj hRgdS U6k72","promoTCsIcon":"qMMSj","promoTCs":"k230U"};